<template>
  <div class="bidders-list tab-table p-2">
    <BiddersTable
            :delete-permission="'delete_bidder'"
            :change-permission="'change_bidder'"
            :auction="sale"
            enable-frontend-export
            :exclude-columns="['sale_no']"
            :exclude-search-fields="['sale_no']"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import BiddersTable from "../../../bidders/BiddersTable";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: biddersMapActions} = createNamespacedHelpers('bidders');

  export default {
    name: "BiddersList",
    components: {BiddersTable},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...biddersMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid}
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
